import { useCallback, useState } from 'react';
import { BlobServiceClient } from '@azure/storage-blob';
import { blobToPlatformNotifications } from '../utils';
export const useAzureStorageBlobs = ({ storageUrl, storageContainer, authToken }) => {
    const [containerClient] = useState(() => new BlobServiceClient(`${storageUrl}?${authToken}`).getContainerClient(storageContainer));
    const getNotifications = useCallback(async (filePath) => {
        const blobClient = containerClient.getBlobClient(filePath);
        const downloadBlockBlobResponse = await blobClient.download();
        return await blobToPlatformNotifications(await downloadBlockBlobResponse.blobBody);
    }, [containerClient]);
    return {
        listFilesInFolder: containerClient.listBlobsByHierarchy.bind(containerClient),
        listAllFiles: containerClient.listBlobsFlat.bind(containerClient),
        getNotifications,
        containerClient,
    };
};
//# sourceMappingURL=useAzureStorageBlobs.js.map